import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import Apoiadores from '../campos/apoiadores';
import ContribuicaoComunidade from '../campos/contribuicaoComunidade';
import FotosVideos from '../campos/fotosVideos';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.aprendizagem;
export default function Aprendizagem() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({
      type: 'setEtapa',
      payload: etapa,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <ContribuicaoComunidade />
        <Apoiadores />
        <FotosVideos etapa={etapa} />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
